import { DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCalculateEscrowInterest extends Layout {
    excludabletextboxEscrowAccounts: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    sourceCalculateEscrowInterest: DataSource;
    textboxPeriodDates: Textbox;
    textboxPostingDate: Textbox;
    textboxReportType: Textbox;
}
